import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "../../axios";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";

const HowToUseVideos = () => {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get("how-to-use-videos/all")
      .then((res) => {
        setItems(res?.data || []);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error("Something went wrong!");
        console.log(err);
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="privacy_policy p-5 text-left">
      <div className="page-title ">
        <h1>Video Upload</h1>
      </div>

      <div className="row ml-n4 search">
        <div className="col-md-9" />
        <div className="col-md-3">
          <Link to="/how-to-use-videos/add" className="myButton">
            Add New
          </Link>
        </div>
      </div>

      <div className="listimi-tabela">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="listimi-head">
              <div className="row text-center">
                <div className="col-1">ID</div>
                <div className="col-4">Title</div>
                <div className="col-1">ALB</div>
                <div className="col-1">SRB</div>
                <div className="col-1">ENG</div>
                <div className="col-2">Video</div>
                <div className="col-1 hideme"> </div>
              </div>
            </div>
            {items?.map((item) => (
              <div className="listimi showme" key={item.id}>
                <div className="row text-center align-items-center">
                  <div className="col-1">{item.id}</div>
                  <div className="col-4">
                    <h6>{item.title_al || item.title || "-"}</h6>
                  </div>

                  <div className="col-1">
                    {item.title_al === null || item.title_al === "" ? (
                      <i className="far fa-times-circle text-danger"></i>
                    ) : (
                      <i className="far fa-check-circle text-success"></i>
                    )}
                  </div>

                  <div className="col-1">
                    {item.title_sr === null || item.title_sr === "" ? (
                      <i className="far fa-times-circle text-danger"></i>
                    ) : (
                      <i className="far fa-check-circle text-success"></i>
                    )}
                  </div>

                  <div className="col-1">
                    {item.title_en === null || item.title_en === "" ? (
                      <i className="far fa-times-circle text-danger"></i>
                    ) : (
                      <i className="far fa-check-circle text-success"></i>
                    )}
                  </div>

                  <div className="col-2 d-flex justify-content-center">
                    {item.video_url ? (
                      <video
                        src={`${process.env.REACT_APP_UPLOADS}${item.video_url}`}
                        width="100"
                        controls
                      />
                    ) : (
                      "-"
                    )}
                  </div>

                  <div className="col-1 delete">
                    <Link
                      className={"fa fa-trash"}
                      to={`/how-to-use-videos/delete/${item.id}`}
                    ></Link>
                  </div>

                  <div className="col-1 edit">
                    <Link
                      className={"fa fa-edit"}
                      to={`/how-to-use-videos/edit/${item.id}`}
                    ></Link>
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default HowToUseVideos;

